"use strict";
var distill;
(function (distill) {
    var datasets;
    (function (datasets) {
        var views;
        (function (views) {
            var rows;
            (function (rows) {
                class InitArgs {
                    constructor() {
                        this.datasetId = appn.emptyString;
                        this.updateUrl = appn.emptyString;
                        this.pkColumns = [];
                        this.canEdit = false;
                        this.lastUpdatedColumnName = appn.emptyString;
                        this.columnTypes = {};
                        this.requiredColumns = [];
                        this.maxLengths = {};
                        this.columns = [];
                    }
                }
                let _args;
                let _datatable;
                function init(args) {
                    _args = args;
                    createDataTable();
                }
                rows.init = init;
                function createDataTable() {
                    _datatable = appn.dataTable.create('#rows-grid', {
                        sAjaxSource: '../RowsDataTable',
                        aaSorting: [[1, 'asc']],
                        bServerSide: true, bProcessing: true, scrollX: '100%', scrollY: '70vh', ordering: true, colResize: false,
                        fnServerData: (data) => { data.push({ name: 'sCustom_0', value: _args.datasetId }); },
                        fnInitComplete: function () {
                            const $filter = $('.dataTables_filter');
                            const $resetBtn = $(appn.dataTable.FILTER_RESET_BTN);
                            $filter.append($resetBtn);
                            appn.dataTable.addSearchPlaceholder();
                            $resetBtn.on('click', function (e) {
                                e.preventDefault();
                                $filter.find('input').val('');
                                const dataTable = $('#rows-grid').DataTable();
                                dataTable.search('').draw();
                            });
                        },
                        editable: {
                            entityId: _args.datasetId,
                            updateUrl: _args.updateUrl,
                            pkColumns: _args.pkColumns,
                            canEdit: _args.canEdit,
                            lastUpdatedColumnName: _args.lastUpdatedColumnName,
                            columnTypes: _args.columnTypes,
                            requiredColumns: _args.requiredColumns,
                            maxLengths: _args.maxLengths,
                            columns: _args.columns
                        }
                    });
                }
            })(rows = views.rows || (views.rows = {}));
        })(views = datasets.views || (datasets.views = {}));
    })(datasets = distill.datasets || (distill.datasets = {}));
})(distill || (distill = {}));
